import { useEffect } from 'react'
import { SpeakerHighIcon } from '@phosphor-icons/react'
import { useMasterVolumeStore } from './store.ts'
import { Fader } from './Fader.tsx'

export function VolumeControl() {
  const { volume, setVolume } = useMasterVolumeStore()

  // Ensure the audio graph reflects persisted value immediately on mount
  useEffect(() => {
    setVolume(volume)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="flex gap-2 items-center">
      {/* <SpeakerHighIcon weight="fill" size={16} className="text-orange-500" /> */}
      <Fader
        min={0}
        max={1}
        step={0.01}
        value={volume}
        onChange={setVolume}
        className="w-[140px] h-[20px]"
        aria-label="Master volume"
        mode="volume"
      />
    </div>
  )
}
